import { getLiffId, parseLineArg } from "../utils/lineIds";
import { LINE_LIFF_METHODS } from "../components/loginMethods";

type Params = {
  defaultLoginMethod: string;
  subCampaignId?: string;
  qrscanlogId?: string;
  channelSessionId?: string;
  engageGetCreditSession?: string;
  merchantReference?: string;
  isEGC: boolean;
  advertiserLogo?: string;
  handleSubmit: () => void;
};

export const lineLiffSubmit = ({
  defaultLoginMethod,
  subCampaignId,
  qrscanlogId,
  channelSessionId,
  engageGetCreditSession,
  merchantReference,
  isEGC,
  advertiserLogo,
  handleSubmit,
}: Params) => {
  if (!LINE_LIFF_METHODS.includes(defaultLoginMethod)) return;

  const storedUserID = localStorage.getItem("userID");
  if (storedUserID && storedUserID !== "undefined" && storedUserID !== "null" && storedUserID !== "") {
    handleSubmit();
    return;
  }

  // redirect to LIFF
  const lineArg = parseLineArg(defaultLoginMethod);
  const LIFF_ID = getLiffId(lineArg);

  // clear previous session
  localStorage.removeItem("userID");
  localStorage.removeItem("profileName");
  localStorage.removeItem("LINE_AUTH_CALLBACK");

  const url = new URL(window.location.href);
  url.searchParams.set("force_login", "true");
  const currentUrl = url.toString();
  localStorage.setItem("originalLoginUrl", currentUrl);

  const ua = navigator.userAgent;
  const isMobile = /Android|iPhone|iPad|iPod/i.test(ua);

  // Use line://app/ scheme for Mobile to force open the app and bypass browser privacy blocks.
  // Use https://liff.line.me/ for Desktop to allow email/QR login.
  const baseUrl = isMobile
    ? `line://app/${LIFF_ID}`
    : `https://liff.line.me/${LIFF_ID}`;

  const liffUrl = new URL(baseUrl);
  liffUrl.searchParams.append("subcampaign_id", subCampaignId || "");
  liffUrl.searchParams.append("qrscanlog_id", qrscanlogId || "");
  liffUrl.searchParams.append("channel_session_id", channelSessionId || "");
  liffUrl.searchParams.append("engage_get_credit_session", engageGetCreditSession || "");
  liffUrl.searchParams.append("is_egc", isEGC.toString());
  liffUrl.searchParams.append("original_url", currentUrl);
  liffUrl.searchParams.append("login_method", defaultLoginMethod);
  liffUrl.searchParams.append("merchant_reference", merchantReference || "");
  liffUrl.searchParams.append("advertiser_logo", advertiserLogo || "");

  window.location.href = liffUrl.toString();
};
